module.exports = __webpack_public_path__ + "img/homepage-quick-links-chevy.ea11ef51.jpg";